import { CompanySearchRow } from '../../services/service-company-search';

export type MunicipalityOption = { value: string; label: string };

// NFC only: stripping accents would make Habo and Håbo the same municipality.
const comparable = (text: string) => text.normalize('NFC').trim().toLowerCase();

export function municipalityOption(
  town: string | null | undefined,
  municipalities: MunicipalityOption[],
): MunicipalityOption | null {
  if (!town) return null;
  const match = municipalities.find(option => comparable(option.value) === comparable(town));
  return match ? { ...match } : null;
}

export function registerIdentity(company: CompanySearchRow, municipalities: MunicipalityOption[]) {
  return {
    organizationNumber: company.orgNumber,
    name: company.name,
    kommun: municipalityOption(company.city, municipalities),
  };
}
